import styled from "styled-components";

export const ComboboxInputIcons = styled.div`
    margin-right: 1rem;

    display: flex;
    gap: 1rem;
`;
